import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-body1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ServiceAccount = _resolveComponent("ServiceAccount")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: _ctx.title,
    ref: "modal"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ServiceAccount, {
          "service-account": _ctx.serviceAccount,
          "onUpdate:serviceAccount": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.serviceAccount) = $event))
        }, null, 8, ["service-account"])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}